<template>
    <div class="card">
      <div class="card-title">事件类型占比</div>
      <div ref="chartRef" class="chart-container"></div>
    </div>
  </template>
  
  <script setup>
  import { onMounted, ref } from 'vue'
  import * as echarts from 'echarts'
  
  const chartRef = ref(null)
  
  const travelData = [
    { value: 40, name: 'APT' },
    { value: 25, name: '重要漏洞' },
    { value: 20, name: '恶意软件' },
    { value: 10, name: '数据泄露' },
    { value: 5, name: '其他' },
  ]
  
  onMounted(() => {
    const chart = echarts.init(chartRef.value)
    chart.setOption({
      tooltip: {
        trigger: 'item',
        formatter: '{b}: {c} ({d}%)'
      },
      legend: {
        bottom: '5%',
        textStyle: { color: '#fff' }
      },
      series: [
        {
          type: 'pie',
          radius: ['40%', '60%'],
          avoidLabelOverlap: false,
          itemStyle: {
            borderRadius: 5,
            borderColor: '#000',
            borderWidth: 2
          },
          label: {
            show: true,
            color: '#fff',
            formatter: '{b}\n{d}%'
          },
          data: travelData
        }
      ]
    })
  })
  </script>
  
  <style scoped>
  .card {
    background: rgba(0, 52, 101, 0.7);
    border-radius: 8px;
    padding: 16px;
    color: #ffffff;
  }
  
  .card-title {
    font-size: 16px;
    font-weight: bold;
    color: #00ffff;
    margin-bottom: 12px;
  }
  
  .chart-container {
    width: 100%;
    height: 260px;
  }
  </style>
  